import { DatePipe } from '@angular/common';
import { Component, effect, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { PerfilAgenteCensalI } from '@shared/interfaces/perfil-agente-censal.interface';
import { ParametricaService } from '@shared/services/api/parametrica.service';
import { CambiarTemaService } from '@shared/services/cambiar-tema.service';

@Component({
  selector: 'app-credencial-agente-censal',
  imports: [DatePipe, RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './credencial-agente-censal.component.html',
  styleUrl: './credencial-agente-censal.component.scss',
})
export class CredencialAgenteCensalComponent {
  private parametricaService = inject(ParametricaService);
  temaService = inject(CambiarTemaService);
  documento_identidad = input.required<string>();
  perfil = signal<PerfilAgenteCensalI | null>(null);
  constructor() {
    effect(() => {
      if (this.documento_identidad()) {
        this.cargarPerfilAgenteCensal();
      }
    });
  }
  cargarPerfilAgenteCensal() {
    this.parametricaService.getPerfilAgenteCensal(this.documento_identidad()).subscribe({
      next: ({ data }) => {
        this.perfil.set(data);
      },
      error: (error) => {
        this.perfil.set(null);
      },
    });
  }
}
